
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/uxcat",
      function () {
        return require("private-next-pages/uxcat/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/uxcat"])
      });
    }
  